import Coupons from "./components/Coupons";

const Routes = [
    {
        path: "/",
        component: Coupons,
    },
];

export default Routes;
